import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useDropdown } from '@scramble/hooks';
import {
  EXAMPLE_DATA_ADVANCED_6,
  EXAMPLE_DATA_ADVANCED_PLUS_6,
  EXAMPLE_DATA_BASIC_6,
} from './ExampleTable/data';
import { TARIFF_PLANS, TARIFF_PLANS_INFO } from '../../constants';
import IconCalendar from './icon_calendar.svg';
import IconArrow from './icon_chevron.svg';
import { ExampleTable } from './ExampleTable';
import s from './index.module.scss';

export const RepaymentSchedule = ({ plan }) => {
  const { t } = useTranslation('plans-v5');
  const { standard, advanced } = TARIFF_PLANS;
  const { ref, open, setOpen } = useDropdown()

  return (
    <div className={s.wrapper} ref={ref}>
      <div className={classnames(s.header, open && s.header_active)} onClick={() => setOpen(!open)}>
        <div className={s.header_left}>
          <img src={IconCalendar} alt="icon" width={24} height={24} />
          <div className={classnames(s.title, 'f-article-regular')}>
            {t('schedule.repayment_schedule_example')}
          </div>
        </div>
        <img
          className={classnames(s.arrow, open && s.arrow_active)}
          src={IconArrow}
          alt="icon"
          width={24}
          height={24}
        />
      </div>
      <div className={classnames(s.dropdown, open && s.dropdown_active)}>
        <div className={s.dropdown_inner}>
          <div className={s.table}>
            <div className={s.summary}>
              <div className={s.block}>
                <div className="f-16 f-400">{t('schedule.loan_amount')}</div>
                <div className="f-20 f-600">€10’000</div>
              </div>
              <div className={s.block}>
                <div className="f-16 f-400">{t('schedule.origination_date')}</div>
                <div className="f-20 f-600">15.01.2025</div>
              </div>
              <div className={s.block}>
                <div className="f-16 f-400">{t('schedule.flat_fee')}</div>
                <div className="f-20 f-600">{TARIFF_PLANS_INFO[plan].flat_fee}</div>
              </div>
              <div className={s.block}>
                <div className="f-16 f-400">{t('schedule.monthly_repayment')}</div>
                <div className="f-20 f-600">{TARIFF_PLANS_INFO[plan].principal}</div>
              </div>
            </div>
            <ExampleTable
              data={
                plan === standard
                  ? EXAMPLE_DATA_BASIC_6
                  : plan === advanced
                    ? EXAMPLE_DATA_ADVANCED_6
                    : EXAMPLE_DATA_ADVANCED_PLUS_6
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
